/*
  Barklie productpagina (sections/barklie-pdp-main.liquid).
  Galerij 1-op-1 de referentiesite `.wf-gallery` (gemeten 13 okt 2026):
  - mobiel (<768): slides naast elkaar met scroll-snap (vegen), voortgangsbalk (breedte 1/aantal, schuift mee in .2s),
    thumbnails 82px; met de muis slepen via barklie-drag-scroll.js.
  - desktop (>=768): één slide zichtbaar, pijlen links/rechts (rondgaand), schuifanimatie .4s cubic-bezier(.4,0,.2,1)
    via klassen --in-next/--in-prev/--out (keyframes in barklie.css), slepen/vegen met muis of vinger, thumbnails 124px.
  - de actieve thumbnail schuift in beeld; bij een andere variant: andere set beelden, terug naar beeld 1 zonder animatie.
  Variant: sectie.bkPdp.setVariant(variant) wisselt galerij, subregel en ?variant= in de URL en stuurt `bk:pdp:variant`.
  Keuzes (P3, referentie `.wf-buybox` / `.wf-bandbox`): gewicht = dropdown (mobiel) of knoppen (desktop); elke gewichtsklasse/band
  wijst naar een "stand" ([data-bk-plans]: variant + 3 plan-kaarten, door Liquid vooraf berekend). De gekozen kaart blijft
  dezelfde (1e/2e/3e) bij een andere klasse, volgens referentie. Knop = Dawn product-form (id, quantity, selling_plan).
  Onder de knop (P4): info-ballonnen, afteltimer, uitklapblokken.
  Variant Bundels (K1, collagen): de bundelkaarten zijn een gewone [data-bk-plans]-groep; het abonnementsvinkje
  ([data-bk-sub], alleen met selling plans) wisselt prijs + selling_plan; knop met data-format="price-first" = "prijs • label".
*/
(function () {
  var MQ = window.matchMedia('(min-width: 768px)');
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SWIPE_MIN = 40; /* px: zo ver slepen/vegen = volgend beeld (desktop) */
  var ANIM = ['bk-pdp__slide--out', 'bk-pdp__slide--next', 'bk-pdp__slide--prev', 'bk-pdp__slide--in-next', 'bk-pdp__slide--in-prev'];

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[–—]/g, '-').replace(/\s+/g, '');
  }

  function Gallery(el) {
    this.el = el;
    this.stage = el.querySelector('[data-bk-gal-stage]');
    this.track = el.querySelector('[data-bk-gal-track]');
    this.rail = el.querySelector('[data-bk-gal-rail]');
    this.barFill = el.querySelector('[data-bk-gal-bar] span');
    this.slides = Array.prototype.slice.call(el.querySelectorAll('[data-bk-gal-slide]'));
    this.thumbs = Array.prototype.slice.call(el.querySelectorAll('[data-bk-gal-thumb]'));
    this.title = el.getAttribute('data-title') || '';
    this.tagged = this.slides.some(function (s) { return !!s.getAttribute('data-bk-set'); });
    this.list = [];
    this.pos = 0;
    this.scrollTimer = null;
    this.ignoreScroll = false;
    var self = this;

    this.slides.forEach(function (s, i) { if (!s.hidden) self.list.push(i); });
    if (!this.list.length) this.list = this.slides.map(function (s, i) { return i; });
    this.slides.forEach(function (s, i) { if (s.classList.contains('is-active')) self.pos = Math.max(0, self.list.indexOf(i)); });

    var prev = el.querySelector('[data-bk-gal-prev]');
    var next = el.querySelector('[data-bk-gal-next]');
    if (prev) prev.addEventListener('click', function () { self.step(-1); });
    if (next) next.addEventListener('click', function () { self.step(1); });

    this.thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        var p = self.list.indexOf(i);
        if (p < 0 || p === self.pos) return;
        self.go(p, p > self.pos ? 1 : -1);
      });
    });

    /* mobiel: de scrollpositie bepaalt het actieve beeld */
    this.track.addEventListener('scroll', function () {
      if (MQ.matches || self.ignoreScroll || self.desktop !== MQ.matches) return;
      var w = self.slideStep();
      if (!w) return;
      var p = Math.max(0, Math.min(self.list.length - 1, Math.round(self.track.scrollLeft / w)));
      if (p !== self.pos) self.setActive(p, false);
    }, { passive: true });

    /* desktop: slepen (muis) of vegen (vinger) */
    var startX = null, startY = 0, pid = null;
    this.stage.addEventListener('pointerdown', function (e) {
      if (!MQ.matches || self.list.length < 2) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('button')) return;
      startX = e.clientX; startY = e.clientY; pid = e.pointerId;
    });
    window.addEventListener('pointerup', function (e) {
      if (startX === null || e.pointerId !== pid) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      startX = null;
      if (Math.abs(dx) >= SWIPE_MIN && Math.abs(dx) > Math.abs(dy)) self.step(dx < 0 ? 1 : -1);
    });
    window.addEventListener('pointercancel', function () { startX = null; });
    this.stage.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* toetsenbord: pijltjes op de galerij */
    this.stage.addEventListener('keydown', function (e) {
      if (!MQ.matches) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); self.step(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.step(-1); }
    });

    /* wisselen mobiel/desktop of andere breedte: zelfde beeld houden */
    this.desktop = MQ.matches;
    var onMode = function () { self.desktop = MQ.matches; self.clearAnim(); self.syncTrack(false); self.revealThumb(false); };
    if (MQ.addEventListener) MQ.addEventListener('change', onMode); else MQ.addListener(onMode);
    var rz = null;
    window.addEventListener('resize', function () {
      if (MQ.matches) return;
      self.ignoreScroll = true;
      clearTimeout(rz);
      rz = setTimeout(function () { self.ignoreScroll = false; self.syncTrack(false); }, 150);
    });

    this.render(false);
  }

  Gallery.prototype.slideStep = function () {
    var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return this.track.clientWidth + gap;
  };

  Gallery.prototype.clearAnim = function () {
    this.slides.forEach(function (s) { ANIM.forEach(function (c) { s.classList.remove(c); }); });
  };

  Gallery.prototype.step = function (dir) {
    var n = this.list.length;
    if (n < 2) return;
    this.go((this.pos + dir + n) % n, dir);
  };

  Gallery.prototype.go = function (p, dir) {
    if (p === this.pos) return;
    if (MQ.matches) {
      var from = this.slides[this.list[this.pos]];
      var to = this.slides[this.list[p]];
      this.clearAnim();
      if (!RM.matches && from && to) {
        from.classList.add('bk-pdp__slide--out', dir > 0 ? 'bk-pdp__slide--next' : 'bk-pdp__slide--prev');
        to.classList.add(dir > 0 ? 'bk-pdp__slide--in-next' : 'bk-pdp__slide--in-prev');
      }
      this.setActive(p, true);
    } else {
      this.setActive(p, true);
      this.syncTrack(!RM.matches);
    }
  };

  Gallery.prototype.setActive = function (p, smoothThumb) {
    this.pos = p;
    this.render(smoothThumb);
  };

  Gallery.prototype.render = function (smoothThumb) {
    var self = this, active = this.list[this.pos], n = this.list.length;
    this.slides.forEach(function (s, i) { s.classList.toggle('is-active', i === active); });
    this.thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === active ? 'true' : 'false'); });
    this.el.setAttribute('data-count', String(n));
    if (this.barFill) {
      this.barFill.style.width = (100 / n) + '%';
      this.barFill.style.marginInlineStart = (100 * this.pos / n) + '%';
    }
    /* pauzeer video's die niet zichtbaar zijn */
    this.slides.forEach(function (s, i) {
      var v = s.querySelector('video');
      if (v && i !== active && !v.paused) v.pause();
    });
    this.revealThumb(smoothThumb);
  };

  /* mobiel: track naar het actieve beeld scrollen */
  Gallery.prototype.syncTrack = function (smooth) {
    if (MQ.matches) return;
    var self = this, left = this.pos * this.slideStep();
    if (Math.abs(this.track.scrollLeft - left) < 1) return;
    if (smooth) {
      this.track.scrollTo({ left: left, behavior: 'smooth' });
    } else {
      this.ignoreScroll = true;
      this.track.scrollLeft = left;
      requestAnimationFrame(function () { self.ignoreScroll = false; });
    }
  };

  /* actieve thumbnail binnen de rij houden */
  Gallery.prototype.revealThumb = function (smooth) {
    if (!this.rail) return;
    var t = this.thumbs[this.list[this.pos]];
    if (!t || t.hidden) return;
    var r = this.rail.getBoundingClientRect(), tr = t.getBoundingClientRect(), d = 0;
    if (tr.left < r.left) d = tr.left - r.left;
    else if (tr.right > r.right) d = tr.right - r.right;
    if (!d) return;
    this.rail.scrollBy({ left: d, behavior: smooth && !RM.matches ? 'smooth' : 'auto' });
  };

  /* andere variant: andere set beelden (zie uitleg in de sectie) */
  Gallery.prototype.setVariant = function (variant, label) {
    var vals = (variant.options || []).map(norm);
    var matched = [], untagged = [], all = [];
    this.slides.forEach(function (s, i) {
      all.push(i);
      var set = s.getAttribute('data-bk-set');
      if (!set) { untagged.push(i); return; }
      var hit = set.split('|').some(function (t) { return t && vals.indexOf(t) > -1; });
      if (hit) matched.push(i);
    });
    var list = (!matched.length && !untagged.length) ? all : all.filter(function (i) {
      return matched.indexOf(i) > -1 || untagged.indexOf(i) > -1;
    });
    var same = list.length === this.list.length && list.every(function (v, k) { return v === this.list[k]; }, this);
    var startPos = 0;
    if (!this.tagged && variant.featured_media) {
      var idx = -1;
      this.slides.forEach(function (s, i) { if (String(s.getAttribute('data-media-id')) === String(variant.featured_media.id)) idx = i; });
      if (idx > -1) startPos = Math.max(0, list.indexOf(idx));
    } else if (same) {
      startPos = this.pos;
    }

    this.list = list;
    this.slides.forEach(function (s, i) { s.hidden = list.indexOf(i) < 0; });
    this.thumbs.forEach(function (t, i) { t.hidden = list.indexOf(i) < 0; });
    this.clearAnim();
    this.pos = startPos;
    if (label) {
      this.track.setAttribute('aria-label', label + ' images');
      if (this.rail) this.rail.setAttribute('aria-label', label);
    }
    if (!same && this.rail) this.rail.scrollLeft = 0;
    this.render(false);
    this.syncTrack(false);
  };

  function slice(list) { return Array.prototype.slice.call(list || []); }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* bedrag in centen -> tekst volgens shop.money_format (bv. "${{amount}}") */
  function formatMoney(cents, format) {
    var n = (Number(cents) || 0) / 100;
    function fmt(dec, thou, sep) {
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return p.join(sep);
    }
    var f = format || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return fmt(0, ',', '.');
      if (key === 'amount_with_comma_separator') return fmt(2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
      return fmt(2, ',', '.');
    });
  }

  /* Info-knop met ballon (snippets/barklie-pdp-tip.liquid), referentie `.wf-infotip` */
  var openTip = null;
  function Tip(el) {
    var self = this;
    this.el = el;
    this.btn = el.querySelector('.bk-pdp__tip-mark');
    this.pop = el.querySelector('.bk-pdp__tip-pop');
    this.pointer = el.querySelector('.bk-pdp__tip-pointer');
    if (!this.btn || !this.pop) return;
    this.btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (self.isOpen()) self.hide(); else self.show();
    });
    var close = el.querySelector('[data-bk-tip-close]');
    if (close) close.addEventListener('click', function (e) { e.preventDefault(); self.hide(); self.btn.focus(); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.isOpen()) { e.stopPropagation(); self.hide(); self.btn.focus(); }
    });
  }
  Tip.prototype.isOpen = function () { return this.btn.getAttribute('aria-expanded') === 'true'; };
  Tip.prototype.show = function () {
    if (openTip && openTip !== this) openTip.hide();
    openTip = this;
    this.pop.hidden = false;
    this.btn.setAttribute('aria-expanded', 'true');
    this.place();
  };
  Tip.prototype.hide = function () {
    this.pop.hidden = true;
    this.btn.setAttribute('aria-expanded', 'false');
    if (openTip === this) openTip = null;
  };
  /* 'right' = naast de knop vanaf 768px (CSS); anders gecentreerd onder de knop, binnen het scherm (16px marge) */
  Tip.prototype.place = function () {
    var right = this.el.getAttribute('data-placement') === 'right' && MQ.matches;
    this.el.classList.toggle('is-right', right);
    this.pop.style.left = '';
    if (this.pointer) this.pointer.style.left = '';
    if (right) return;
    var b = this.btn.getBoundingClientRect();
    var w = this.pop.offsetWidth;
    var left = b.width / 2 - w / 2;
    var vw = document.documentElement.clientWidth;
    var absLeft = b.left + left;
    if (absLeft < 16) left += 16 - absLeft;
    if (absLeft + w > vw - 16) left -= absLeft + w - (vw - 16);
    this.pop.style.left = left + 'px';
    if (this.pointer) this.pointer.style.left = (b.width / 2 - left - 8) + 'px';
  };
  document.addEventListener('pointerdown', function (e) {
    if (openTip && !openTip.el.contains(e.target)) openTip.hide();
  });

  /* Goede doelen: dia's om de paar seconden laten overvloeien; stopt bij hover/focus en buiten beeld */
  function Charity(el) {
    var slides = slice(el.querySelectorAll('[data-bk-charity-slide]'));
    if (slides.length < 2) return;
    var ms = (parseInt(el.getAttribute('data-interval'), 10) || 5) * 1000;
    var i = 0, timer = null, paused = false, visible = true;
    slides.forEach(function (s) { var img = s.querySelector('img'); if (img) img.loading = 'eager'; });
    function show(n) {
      slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true');
      i = n % slides.length;
      slides[i].classList.add('is-active'); slides[i].removeAttribute('aria-hidden');
    }
    function run() {
      clearInterval(timer);
      if (!paused && visible) timer = setInterval(function () { show(i + 1); }, ms);
    }
    el.addEventListener('mouseenter', function () { paused = true; run(); });
    el.addEventListener('mouseleave', function () { paused = false; run(); });
    el.addEventListener('focusin', function () { paused = true; run(); });
    el.addEventListener('focusout', function () { paused = false; run(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; run(); }).observe(el);
    }
    run();
  }

  function Pdp(root) {
    var self = this;
    this.root = root;
    var json = root.querySelector('[data-bk-pdp-variants]');
    this.variants = json ? JSON.parse(json.textContent) : [];
    var galEl = root.querySelector('[data-bk-gallery]');
    this.gallery = galEl ? new Gallery(galEl) : null;

    var box = root.querySelector('[data-bk-box]');
    this.moneyFormat = box ? box.getAttribute('data-money-format') : '';
    this.form = root.querySelector('[data-bk-pdp-form] form');
    this.atc = root.querySelector('[data-bk-pdp-atc]');
    this.atcLabel = root.querySelector('[data-bk-atc-label]');
    this.inId = root.querySelector('[data-bk-input-id]');
    this.inQty = root.querySelector('[data-bk-input-qty]');
    this.inSp = root.querySelector('[data-bk-input-sp]');
    this.once = root.querySelector('[data-bk-once]');
    this.upsell = root.querySelector('[data-bk-upsell]');
    this.groups = slice(root.querySelectorAll('[data-bk-plans]'));
    this.sizeBtns = slice(root.querySelectorAll('[data-bk-sizes] [data-bk-size]'));
    this.options = slice(root.querySelectorAll('[data-bk-listbox] [data-bk-size]'));
    this.select = root.querySelector('[data-bk-select]');
    this.trigger = root.querySelector('[data-bk-trigger]');
    this.triggerValue = root.querySelector('[data-bk-trigger-value]');
    this.listbox = root.querySelector('[data-bk-listbox]');

    this.current = this.inId ? this.byId(this.inId.value) : null;
    this.group = null;
    this.planIdx = 0;
    for (var g = 0; g < this.groups.length; g++) if (!this.groups[g].hidden) { this.group = this.groups[g]; break; }
    if (this.group) {
      this.radios(this.group).forEach(function (r, i) { if (r.checked) self.planIdx = i; });
      this.band = this.group.getAttribute('data-band');
    } else {
      var on = this.sizeBtns.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0];
      this.band = on ? on.getAttribute('data-bk-size') : '';
    }

    /* gewicht: knoppen (desktop) */
    this.sizeBtns.forEach(function (b, i) {
      b.addEventListener('click', function () { self.selectBand(b.getAttribute('data-bk-size')); });
      b.addEventListener('keydown', function (e) {
        var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = self.sizeBtns[(i + d + self.sizeBtns.length) % self.sizeBtns.length];
        n.focus();
        self.selectBand(n.getAttribute('data-bk-size'));
      });
    });

    /* gewicht: dropdown (mobiel) */
    if (this.trigger && this.listbox) {
      this.trigger.addEventListener('click', function () { if (self.listbox.hidden) self.openList(false); else self.closeList(false); });
      this.trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); self.openList(true); }
        if (e.key === 'Escape' && !self.listbox.hidden) { e.preventDefault(); self.closeList(true); }
      });
      this.options.forEach(function (o, i) {
        o.addEventListener('click', function () {
          self.selectBand(o.getAttribute('data-bk-size'));
          self.closeList(true);
        });
        o.addEventListener('keydown', function (e) {
          var t = null;
          if (e.key === 'ArrowDown') t = self.options[Math.min(i + 1, self.options.length - 1)];
          else if (e.key === 'ArrowUp') t = self.options[Math.max(i - 1, 0)];
          else if (e.key === 'Home') t = self.options[0];
          else if (e.key === 'End') t = self.options[self.options.length - 1];
          else if (e.key === 'Escape') { e.preventDefault(); self.closeList(true); return; }
          else if (e.key === 'Tab') { self.closeList(false); return; }
          if (t) { e.preventDefault(); t.focus(); }
        });
      });
      document.addEventListener('pointerdown', function (e) {
        if (!self.listbox.hidden && self.select && !self.select.contains(e.target)) self.closeList(false);
      });
      MQ.addEventListener ? MQ.addEventListener('change', function () { self.closeList(false); }) : MQ.addListener(function () { self.closeList(false); });
    }

    /* plan-kaarten (native radio's) */
    root.addEventListener('change', function (e) {
      var r = e.target;
      if (!r.matches || !r.matches('[data-bk-plans] input[type="radio"]')) return;
      var group = r.closest('[data-bk-plans]');
      if (group !== self.group) return;
      self.planIdx = self.radios(group).indexOf(r);
      self.updateCta();
    });

    /* variant Bundels: abonnementsvinkje */
    this.subBox = root.querySelector('[data-bk-sub]');
    if (this.subBox) this.subBox.addEventListener('change', function () { self.updateCta(); });
    root.querySelectorAll('[data-bk-dose]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        /* Hondenmaat kiest een bestaande bundel; handmatige kaartkeuze blijft mogelijk. */
        var qty = { '1': '1', '2': '3', '3': '5' }[radio.value];
        var card = self.group && self.group.querySelector('[data-bk-plan][data-qty="' + qty + '"]');
        var choice = card && card.querySelector('input[type="radio"]');
        if (choice && !choice.disabled) {
          choice.checked = true;
          self.planIdx = self.radios(self.group).indexOf(choice);
        }
        self.updateCta();
      });
    });

    /* "Buy once": zelfde variant + aantal, zonder selling plan, direct in de winkelwagen (drawer) */
    if (this.once) this.once.addEventListener('click', function () { self.buyOnce(); });

    slice(root.querySelectorAll('[data-bk-tip]')).forEach(function (el) { el.bkTip = new Tip(el); });
    window.addEventListener('resize', function () { if (openTip && root.contains(openTip.el)) openTip.place(); });
    slice(root.querySelectorAll('[data-bk-charity]')).forEach(function (el) { Charity(el); });

    /* uitklapblokken (referentie `.wf-accordion-header`): meerdere tegelijk open */
    slice(root.querySelectorAll('[data-bk-acc]')).forEach(function (item) {
      var btn = item.querySelector('.bk-pdp__acc-btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        item.classList.toggle('is-open', open);
      });
    });

    /* link "View the complete ingredient list." opent het uitklapblok en scrolt ernaartoe */
    root.querySelectorAll('[data-bk-open-target]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').replace(/^#/, '');
        var target = id && document.getElementById(id);
        e.preventDefault();
        if (!target) return;
        if (target.tagName === 'DETAILS') target.open = true;
        var btn = target.matches('[aria-expanded="false"]') ? target : target.querySelector('[aria-expanded="false"]');
        if (btn) btn.click();
        var focusButton = target.querySelector('.bk-pdp__acc-btn');
        if (focusButton) focusButton.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth', block: 'start' });
      });
    });

    this.updateCta();
  }

  Pdp.prototype.byId = function (id) {
    for (var i = 0; i < this.variants.length; i++) if (String(this.variants[i].id) === String(id)) return this.variants[i];
    return null;
  };

  Pdp.prototype.radios = function (group) {
    return slice(group.querySelectorAll('input[type="radio"]'));
  };

  Pdp.prototype.openList = function (focusSelected) {
    this.listbox.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.select.classList.add('is-open');
    if (focusSelected) {
      var sel = this.options.filter(function (o) { return o.getAttribute('aria-selected') === 'true'; })[0] || this.options[0];
      if (sel) sel.focus();
    }
  };

  Pdp.prototype.closeList = function (focusTrigger) {
    if (!this.listbox || this.listbox.hidden) return;
    this.listbox.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
    this.select.classList.remove('is-open');
    if (focusTrigger) this.trigger.focus();
  };

  /* gewichtsklasse/band kiezen -> stand (variant + plannen); band met de huidige fles heeft voorrang */
  Pdp.prototype.selectBand = function (key) {
    var cands = this.groups.filter(function (g) { return g.getAttribute('data-band') === key; });
    var cur = this.current ? String(this.current.id) : '';
    if (cands.length) {
      var g = cands.filter(function (x) { return x.getAttribute('data-variant') === cur; })[0] || cands[0];
      this.activate(g, false);
      return;
    }
    /* geen plannen: gewoon de variant met die waarde */
    this.band = key;
    this.updateSizeUi();
    for (var i = 0; i < this.variants.length; i++) {
      if (norm(this.variants[i].option1) === key) { this.applyVariant(this.variants[i]); break; }
    }
    this.updateServing();
    this.updateCta();
  };

  Pdp.prototype.activate = function (group, force) {
    this.group = group;
    this.groups.forEach(function (g) { g.hidden = g !== group; });
    var radios = this.radios(group);
    var idx = Math.min(this.planIdx, radios.length - 1);
    if (radios[idx]) radios[idx].checked = true;
    this.band = group.getAttribute('data-band');
    this.updateSizeUi();
    var v = this.byId(group.getAttribute('data-variant'));
    if (v && (force || !this.current || String(v.id) !== String(this.current.id))) this.applyVariant(v);
    else if (v) this.current = v;
    this.updateServing();
    this.updateCta();
  };

  Pdp.prototype.updateSizeUi = function () {
    var key = this.band, label = '';
    this.sizeBtns.forEach(function (b) {
      var on = b.getAttribute('data-bk-size') === key;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.setAttribute('tabindex', on ? '0' : '-1');
    });
    this.options.forEach(function (o) {
      var on = o.getAttribute('data-bk-size') === key;
      o.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) label = o.getAttribute('data-label') || o.textContent;
    });
    if (this.triggerValue && label) this.triggerValue.textContent = label;
  };

  Pdp.prototype.updateServing = function () {
    var key = this.band;
    slice(this.root.querySelectorAll('.bk-pdp__guide:not(.bk-pdp__guide--all) [data-bk-serving]')).forEach(function (li) {
      li.hidden = li.getAttribute('data-bk-serving') !== key;
    });
  };

  Pdp.prototype.checkedCard = function () {
    if (!this.group) return null;
    var r = this.group.querySelector('input[type="radio"]:checked');
    return r ? r.closest('[data-bk-plan]') : null;
  };

  /* formulier + knop + "Buy once" bijwerken voor de gekozen stand en kaart */
  Pdp.prototype.updateCta = function () {
    var v = this.current;
    if (!v) return;
    var card = this.checkedCard();
    var qty = card ? card.getAttribute('data-qty') : '1';
    var sp = card ? card.getAttribute('data-sp') : '';
    /* variant Bundels: abonnementsvinkje = selling plan + abo-prijs per kaart (alleen als het product selling plans heeft) */
    var sub = !!(this.subBox && this.subBox.checked);
    if (this.subBox) {
      slice(this.root.querySelectorAll('[data-bk-plans] [data-bk-plan]')).forEach(function (c) {
        var p = c.querySelector('[data-bk-bundle-price]'), s = c.querySelector('[data-bk-bundle-compare]');
        var t = c.getAttribute(sub ? 'data-sp-total' : 'data-total'), cmp = c.getAttribute(sub ? 'data-sp-compare' : 'data-compare');
        if (p) p.textContent = t;
        if (s) { s.textContent = cmp || ''; s.hidden = !cmp; }
        /* "each" en "Save %" rekenen mee met het abonnement (Noah 22 okt 2026) */
        var e = c.querySelector('[data-bk-bundle-each]'), sv = c.querySelector('[data-bk-bundle-save]');
        var et = c.getAttribute(sub ? 'data-sp-each' : 'data-each'), st = c.getAttribute(sub ? 'data-sp-save' : 'data-save');
        if (e && et) e.textContent = et;
        if (sv && st) sv.textContent = st;
      });
      if (sub && card) sp = card.getAttribute('data-sp-id') || '';
    }
    /* Voorraadduur en dagprijs volgen de dosering; bundelprijzen en leverplan blijven gelijk. */
    var doseChoice = this.root.querySelector('[data-bk-dose]:checked');
    if (doseChoice) {
      var dose = Number(doseChoice.value);
      var moneyFormat = this.moneyFormat;
      var summary = this.root.querySelector('[data-bk-dose-summary]');
      if (summary) summary.textContent = dose + ' mL a day · ' + (60 / dose) + ' days per 60 mL bottle';
      this.root.querySelectorAll('[data-bk-liquid-dose]').forEach(function (guide) {
        guide.hidden = Number(guide.getAttribute('data-bk-liquid-dose')) !== dose;
      });
      slice(this.root.querySelectorAll('[data-bk-plan]')).forEach(function (c) {
        var daily = c.querySelector('[data-bk-daily]');
        if (!daily) return;
        var days = Number(c.getAttribute('data-qty')) * 60 / dose;
        var cents = Number(daily.getAttribute(sub ? 'data-sub-cents' : 'data-once-cents'));
        daily.textContent = formatMoney(Math.round(cents / days), moneyFormat) + '/day';
        var dailyCompare = c.querySelector('[data-bk-daily-compare]');
        if (dailyCompare) {
          var compareCents = Number(dailyCompare.getAttribute('data-compare-cents'));
          dailyCompare.textContent = formatMoney(Math.round(compareCents / days), moneyFormat);
          dailyCompare.hidden = compareCents <= cents;
        }
        var supply = c.querySelector('[data-bk-supply]');
        if (supply) supply.textContent = days + '-day supply';
      });
    }
    var packId = card && card.getAttribute('data-bundle-variant-id');
    if (packId) v = this.byId(packId) || v;
    if (this.form) this.form.dataset.bkBundle = packId ? 'true' : '';
    if (this.inId) this.inId.value = v.id;
    if (this.inQty) this.inQty.value = packId ? '1' : (qty || '1');
    if (this.inSp) {
      this.inSp.value = sp || '';
      this.inSp.disabled = !sp;
    }
    if (!this.atc) return;
    var label = this.atcLabel || this.atc.querySelector('span');
    if (v.available) {
      this.atc.removeAttribute('disabled');
      var total = card ? card.getAttribute(sub ? 'data-sp-total' : 'data-total') : formatMoney(v.price, this.moneyFormat);
      var compare = card ? card.getAttribute(sub ? 'data-sp-compare' : 'data-compare') : (v.compare_at_price > v.price ? formatMoney(v.compare_at_price, this.moneyFormat) : '');
      var priceHtml = esc(total) + (compare ? '<s>' + esc(compare) + '</s>' : '');
      var text = esc(this.atc.getAttribute('data-label') || 'Add to cart');
      if (label) label.innerHTML = this.atc.getAttribute('data-format') === 'price-first' ? priceHtml + ' • ' + text : text + ' | ' + priceHtml;
      if (this.once) {
        this.once.hidden = false;
        var price = card ? (card.getAttribute('data-once') || card.getAttribute('data-total')) : formatMoney(v.price, this.moneyFormat);
        this.once.textContent = (this.once.getAttribute('data-template') || '').replace('[price]', price);
      }
    } else {
      this.atc.setAttribute('disabled', 'disabled');
      if (label) label.textContent = this.atc.getAttribute('data-sold-out') || (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
      if (this.once) this.once.hidden = true;
    }
  };

  Pdp.prototype.buyOnce = function () {
    if (!this.form || !this.atc || this.atc.disabled) return;
    var sp = this.inSp, wasDisabled = sp ? sp.disabled : true;
    if (sp) sp.disabled = true;
    /* Dawn product-form leest het formulier direct bij submit (synchroon), daarna zetten we het plan terug */
    if (this.form.requestSubmit) this.form.requestSubmit(this.atc);
    else this.atc.click();
    if (sp) sp.disabled = wasDisabled;
  };

  /* galerij, subregel, kaart "Bigger bottle", URL en event voor een andere variant */
  Pdp.prototype.applyVariant = function (variant) {
    var root = this.root;
    this.current = variant;
    var title = this.gallery ? this.gallery.title : '';
    if (this.gallery) this.gallery.setVariant(variant, title + ' gallery, ' + variant.title);

    root.querySelectorAll('[data-bk-meta]').forEach(function (p) {
      p.hidden = String(p.getAttribute('data-bk-meta')) !== String(variant.id);
    });
    if (this.upsell) this.upsell.hidden = String(this.upsell.getAttribute('data-variant')) === String(variant.id);

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}

    root.dispatchEvent(new CustomEvent('bk:pdp:variant', { bubbles: true, detail: { variant: variant } }));
  };

  /* publieke API: andere code kan een variant kiezen */
  Pdp.prototype.setVariant = function (variant) {
    if (!variant) return;
    var id = String(variant.id), band = this.band;
    var cands = this.groups.filter(function (g) { return g.getAttribute('data-variant') === id; });
    var g = cands.filter(function (x) { return x.getAttribute('data-band') === band; })[0] || cands[0];
    if (g) { this.activate(g, true); return; }
    this.applyVariant(variant);
    this.updateCta();
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-bk-pdp]').forEach(function (root) {
      if (root.bkPdp) return;
      root.bkPdp = new Pdp(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
